module.exports = __webpack_public_path__ + "media/yuxin-info.dbc8e112.mp4";